import { BarChart, Bar, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { FONTS, COLORS } from "../constants/theme";

// ─── CustomerIQ ───────────────────────────────────────────────────────────────────
// Persona: VP Customer Success
// Data sources: See constants/modules.js

const KPIs = [
  { label: "NRR", value: "115%", delta: "+11pts YoY", color: "#059669" },
  { label: "GRR", value: "98.2%", delta: "Best-in-class", color: "#059669" },
  { label: "Churn Rate", value: "1.8%", delta: "-0.3pts QoQ", color: "#059669" },
  { label: "Avg Health Score", value: "74/100", delta: "-3pts MoM", color: "#d97706" },
  { label: "At-Risk ARR", value: "$420K", delta: "24 accounts", color: "#e11d48" },
  { label: "Expansion Pipeline", value: "$680K", delta: "Identified", color: "#059669" }
];
const CHART_DATA = [
  {
    "band": "Healthy (80+)",
    "accounts": 142,
    "arr": 4200
  },
  {
    "band": "Neutral (60-79)",
    "accounts": 87,
    "arr": 2100
  },
  {
    "band": "At Risk (40-59)",
    "accounts": 31,
    "arr": 890
  },
  {
    "band": "Critical (<40)",
    "accounts": 12,
    "arr": 420
  }
];

export default function CustomerIQ({ module: mod, theme }) {
  const { surface, border, text, muted, dark } = theme;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {KPIs.map((k, i) => (
          <div key={i} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 12, padding: "16px 18px", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${mod.accent}55, ${mod.accent})` }} />
            <p style={{ color: muted, fontSize: 10, fontFamily: FONTS.mono, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</p>
            <p style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 22, color: text, letterSpacing: "-.02em" }}>{k.value}</p>
            <span style={{ display: "inline-block", marginTop: 6, fontFamily: FONTS.mono, fontSize: 10, padding: "2px 7px", borderRadius: 20, color: k.color, background: k.color + "18" }}>{k.delta}</span>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 14, padding: "20px 24px" }}>
        <p style={{ fontFamily: FONTS.mono, fontSize: 11, color: muted, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 16 }}>Customer Health Distribution</p>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={CHART_DATA} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e243860" />
          <XAxis dataKey="band" tick={{ fill: "#8892b0", fontSize: 11 }} />
          <YAxis tick={{ fill: "#8892b0", fontSize: 11 }} />
          <Tooltip contentStyle={{ background: "#0a0e1a", border: "1px solid #1e2438", borderRadius: 8, fontSize: 11 }} />
          <Legend wrapperStyle={{ fontSize: 11, color: "#8892b0" }} />
          <Bar dataKey="accounts" fill="#059669" radius={[4,4,0,0]} />
          <Bar dataKey="arr" fill="#f59e0b" radius={[4,4,0,0]} />
        </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Insight */}
      <div style={{ background: mod.accent + "10", border: `1px solid ${mod.accent}25`, borderRadius: 12, padding: "14px 18px", display: "flex", gap: 12, alignItems: "flex-start" }}>
        <span style={{ color: mod.accent, fontSize: 16, flexShrink: 0, marginTop: 1 }}>◉</span>
        <div>
          <p style={{ fontFamily: FONTS.mono, fontSize: 10, color: mod.accent, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 4 }}>IQ INSIGHT</p>
          <p style={{ fontSize: 13, color: dark ? "#a0aec0" : "#475569", lineHeight: 1.65 }}>15% of accounts (43) in at-risk or critical bands represent $1.3M ARR — immediate CSM intervention required.</p>
        </div>
      </div>
    </div>
  );
}
